import React from 'react'
import { HightLight } from '../../gameRulesStyle'
import { Content } from './ElementsStyles'
interface Input_props {
  label: string
  value: string
  height?: string
  fontSize?: string
  subLabel: string
}

export default function Increase({
  label,
  value,
  height,
  fontSize,
  subLabel,
}: Input_props) {
  return (
    <Content height={height} fontSize={fontSize}>
      <span>
        {label}{' '}
        <HightLight fontSize='12px !important' background='blue'>
          {subLabel}
        </HightLight>
      </span>
      <div>
        <p>{value}</p>
        <span className='switcher' />
      </div>
    </Content>
  )
}
